import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PreloadAllModules } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { PdfLoadingComponent } from './pdf-loading/pdf-loading.component';
import { ErrorComponent, NotFoundComponent } from '@vinnova/e-tjanster';
import { LoginCallbackComponent } from '@vinnova/auth';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () =>
      import('./features/ansokan-list/ansokan-list.module').then(
        (m) => m.AnsokanListModule,
      ),
  },
  {
    path: 'ansok',
    component: LayoutComponent,
    loadChildren: () =>
      import('./features/ansok/ansok.module').then((m) => m.AnsokModule),
  },
  {
    path: 'pdf-loading',
    component: PdfLoadingComponent,
  },
  {
    path: 'testform/:diarienummer',
    data: { testable: true },
    loadChildren: () =>
      import('./features/preview/preview.module').then((m) => m.PreviewModule),
  },
  {
    path: 'previewform/:diarienummer',
    data: { testable: false },
    loadChildren: () =>
      import('./features/preview/preview.module').then((m) => m.PreviewModule),
  },
  {
    path: 'login-callback',
    component: LoginCallbackComponent,
  },
  {
    path: 'not-found',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'error',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: ErrorComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled',
      canceledNavigationResolution: 'computed',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
